import { Button, ButtonGroup, Col, FormControl, Label, Row, FormGroup, ControlLabel, HelpBlock } from 'react-bootstrap'
import { WellWrapper } from './styles';
import { IStatusList, ITypeList } from '@nkr/models/swap-donors';
import { VoucherStatusType } from "@nkr/enums/voucher-status-type";
import { IListItem } from '@nkr/models/list-item';
import { donorSearchTypeList } from '../donor-search-type-list';
import React from 'react';
import MaskedInput from 'react-maskedinput';

interface IProps {
    isAdmin: boolean,
    fullName: string,
    alias: string,
    email: string,
    remote: number,
    dob: string,
    centerId: number,
    showLimitWarning: boolean,
    donatedStartDate: string,
    donatedEndDate: string,
    compatible: boolean,
    voucherStatus: VoucherStatusType,
    statusList: IStatusList,
    typeList: ITypeList,
    centerList: IListItem[],
    onFilter: (fullName: string, alias: string, email: string, remote: number, dob: string, statusList: IStatusList, types: ITypeList, centerId, donatedStartDate: string, donatedEndDate: string, compatible: boolean, voucherStatus: VoucherStatusType) => void,
    onChange: (name: string, value: any) => void
}

const Search = (props: IProps) => {
    const { alias, statusList, typeList } = props;

    const handleChange = (e: React.FormEvent<FormControl & HTMLInputElement>) => {
        let { name, value } = e.currentTarget;

        if (name == 'centerId' || name == 'remote' || name == 'remote') {
            props.onChange(name, parseInt(value));
        }

        props.onChange(name, value);
    }

    const handleStatusChange = (statusName: string) => {
        props.onChange('status', statusName);
    };

    const handleTypesChange = (typeName: string) => {
        props.onChange('types', typeName);
    };

    const handleFilter = () => {
        let { fullName, alias, email, remote, dob, voucherStatus, statusList, typeList, centerId, donatedStartDate, donatedEndDate, compatible } = props;
        props.onFilter(fullName, alias, email, remote, dob, statusList, typeList, centerId, donatedStartDate, donatedEndDate, compatible, voucherStatus);
    };

    return (
        <WellWrapper bsSize='sm'>
            <Row>
                <Col xs={12}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        <h4>SEARCH</h4>
                        <div>
                            {props.showLimitWarning && (
                                <Label bsStyle='danger'>
                                    More than 1000 donors found. Please add filter criteria to reduce the number of results.
                                </Label>
                            )}
                        </div>
                        <div>
                            <Label style={{ fontSize: '90%' }}>donors must match all criteria provided</Label>
                        </div>
                    </div>
                </Col>
                {props.isAdmin && (
                    <Col xs={12} sm={2}>
                        <FormGroup bsSize='sm'>
                            <Col xs={12} componentClass={ControlLabel}>Center</Col>
                            <Col xs={12}>
                                <FormControl
                                    componentClass={'select'}
                                    name='centerId'
                                    value={props.centerId}
                                    onChange={handleChange}
                                >
                                    <option value={0}>- SELECT -</option>
                                    {props.centerList.map((center, index) =>
                                        <option key={`center-${index}`} value={center.id}>{center.description}</option>
                                    )}
                                </FormControl>
                            </Col>
                        </FormGroup>
                    </Col>
                )}
                <Col xs={12} sm={2}>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>Full Name</Col>
                        <Col xs={12}>
                            <FormControl
                                id='fullName'
                                name='fullName'
                                type='text'
                                placeholder='e.g. J OR John Doe'
                                value={props.fullName}
                                onChange={handleChange} />
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={12} sm={2}>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>Alias</Col>
                        <Col xs={12}>
                            <FormControl
                                id='alias'
                                name='alias'
                                type='text'
                                placeholder='e.g. ABC123'
                                value={props.alias}
                                onChange={handleChange} />
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={12} sm={2}>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>Email</Col>
                        <Col xs={12}>
                            <FormControl
                                id='email'
                                name='email'
                                type='text'
                                placeholder='e.g. joh OR john.doe@example.com'
                                value={props.email}
                                onChange={handleChange} />
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={12} sm={2}>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>Donor Type</Col>
                        <Col xs={12}>
                            <FormControl
                                componentClass='select'
                                name='remote'
                                value={props.remote}
                                onChange={handleChange}
                            >
                                {donorSearchTypeList.map(item =>
                                    <option value={item.id}>{item.description}</option>
                                )}
                            </FormControl>
                        </Col>
                    </FormGroup>
                </Col>

                <Col xs={12} sm={!props.isAdmin ? 3 : 1}>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>DOB</Col>
                        <Col xs={12}>
                            <MaskedInput
                                name='dob'
                                className='form-control'
                                style={{ width: 160 }}
                                mask={'11/11/1111'}
                                value={props.dob}
                                onChange={handleChange}
                            />
                        </Col>
                    </FormGroup>
                </Col>

                <Col xs={12} lg={4} className='filter-group'>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>Status</Col>
                        <Col xs={12}>
                            <div className='filter-flex'>
                                <ButtonGroup>
                                    <input type='button' className={'btn ' + (props.statusList.active ? 'btn-primary active' : 'btn-default')} name='status' value='Active' onClick={() => handleStatusChange('active')} />
                                    <input type='button' className={'btn ' + (props.statusList.inactive ? 'btn-primary active' : 'btn-default')} name='status' value='Inactive' onClick={() => handleStatusChange('inactive')} />
                                    <input type='button' className={'btn ' + (props.statusList.donated ? 'btn-primary active' : 'btn-default')} name='status' value='Donated' onClick={() => handleStatusChange('donated')} />

                                    {props.isAdmin && (
                                        <input type='button' className={'btn ' + (statusList.deleted ? 'btn-primary active' : 'btn-default')} name='types[]' value='Deleted' onClick={() => handleStatusChange('deleted')} />
                                    )}
                                </ButtonGroup>

                                {props.statusList.donated && props.isAdmin == false && (
                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                        <div>Between:&nbsp;</div>
                                        <div>
                                            <FormControl
                                                type='date'
                                                name='donatedStartDate'
                                                value={props.donatedStartDate}
                                                onChange={handleChange} />
                                        </div>
                                        <div>&nbsp;and&nbsp;</div>
                                        <div>
                                            <FormControl
                                                type='date'
                                                name='donatedEndDate'
                                                value={props.donatedEndDate}
                                                onChange={handleChange} />
                                        </div>
                                    </div>
                                )}
                            </div>
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={12} lg={3} className='filter-group'>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>Types {props.compatible != null ? '*' : null}</Col>
                        <Col xs={12}>
                            <ButtonGroup>
                                <input type='button' className={'btn ' + (props.typeList.ndd ? 'btn-primary active' : 'btn-default')} name='types' value='NDDs' disabled={props.compatible != null} onClick={() => handleTypesChange('ndd')} />
                                <input type='button' className={'btn ' + (props.typeList.sv ? 'btn-primary active' : 'btn-default')} name='types' value='Standard Voucher' disabled={props.compatible != null} onClick={() => handleTypesChange('sv')} />
                                <input type='button' className={'btn ' + (props.typeList.fv ? 'btn-primary active' : 'btn-default')} name='types' value='Family Voucher' disabled={props.compatible != null} onClick={() => handleTypesChange('fv')} />
                                <input type='button' className={'btn ' + (props.typeList.paired ? 'btn-primary active' : 'btn-default')} name='types' value='Paired' disabled={props.compatible != null} onClick={() => handleTypesChange('paired')} />
                                <input type='button' className={'btn ' + (props.typeList.remote ? 'btn-primary active' : 'btn-default')} name='types' value='Remote' disabled={props.compatible != null} onClick={() => handleTypesChange('remote')} />
                            </ButtonGroup>
                        </Col>
                    </FormGroup>
                </Col>
                <Col xs={12} lg={2} className='filter-group shift-right-lg'>
                    <FormGroup>
                        <Col xs={12} componentClass={ControlLabel}>Compatible?</Col>
                        <Col xs={12}>
                            <div className='filter-flex'>
                                <ButtonGroup>
                                    <input type='button' className={'btn ' + (props.compatible == true ? 'btn-primary active' : 'btn-default')} name='compatible' value='Yes' onClick={() => props.onChange('compatible', true)} />
                                    <input type='button' className={'btn ' + (props.compatible == false ? 'btn-primary active' : 'btn-default')} name='compatible' value='No' onClick={() => props.onChange('compatible', false)} />
                                    <input type='button' className={'btn ' + (props.compatible == null ? 'btn-primary active' : 'btn-default')} name='compatible' value='Either' onClick={() => props.onChange('compatible', null)} />
                                </ButtonGroup>
                            </div>
                        </Col>
                    </FormGroup>
                </Col>
                {(props.typeList.sv || props.typeList.fv) ? (
                    <Col xs={12} lg={3} className='filter-group'>
                        <FormGroup>
                            <Col xs={12} componentClass={ControlLabel}>Voucher Status</Col>
                            <Col xs={12}>
                                <div className='filter-flex' style={{ justifyContent: 'space-between' }}>
                                    <ButtonGroup>
                                        <input type='button' className={'btn ' + (props.voucherStatus == VoucherStatusType.All ? 'btn-primary active' : 'btn-default')} name='voucherStatus' value='All' onClick={() => props.onChange('voucherStatus', VoucherStatusType.All)} />
                                        <input type='button' className={'btn ' + (props.voucherStatus == VoucherStatusType.Unredeemed ? 'btn-primary active' : 'btn-default')} name='voucherStatus' value='Unredeemed' onClick={() => props.onChange('voucherStatus', VoucherStatusType.Unredeemed)} />
                                        <input type='button' className={'btn ' + (props.voucherStatus == VoucherStatusType.Redeemed ? 'btn-primary active' : 'btn-default')} name='voucherStatus' value='Redeemed' onClick={() => props.onChange('voucherStatus', VoucherStatusType.Redeemed)} />
                                    </ButtonGroup>
                                    <Button bsStyle='primary' style={{ minWidth: 80 }} onClick={handleFilter}>Filter</Button>
                                </div>
                            </Col>
                        </FormGroup>
                    </Col>
                ) : (
                    <Col xs={12} lg={3} className='filter-group'>
                        <FormGroup>
                            <Col xs={12} componentClass={ControlLabel} className='hidden-xs'>&nbsp;</Col>
                            <Col xs={12}>
                                <div className='filter-flex' style={{ justifyContent: 'flex-end' }}>
                                    <Button bsStyle='primary' style={{ minWidth: 80 }} onClick={handleFilter}>Filter</Button>
                                </div>
                            </Col>
                        </FormGroup>
                    </Col>
                )}
            </Row>
            {props.compatible != null && (
                <Row>
                    <Col xs={12}>
                        <FormGroup style={{ marginBottom: 0 }}>
                            <Col xs={12}>
                                <HelpBlock style={{ marginBottom: 0 }}>* The Types filter is disabled, because the <strong>COMPATIBLE</strong> option is set to YES and internally we are looking for directed donors, standard voucher donors, bridge donors, swap saver donors, and real time swap failure donors</HelpBlock>
                            </Col>
                        </FormGroup>
                    </Col>
                </Row>
            )}
        </WellWrapper>
    );
}

export default Search;